// @flow
import React from "react";
import AutoCompleteMedidas from "../auto-complete-medidas";
import SelecaoGrupamentoMedida from "../selecao-grupamento-medida";

import "./selecao-medidas.css";

export default function() {
  return (
    <>
      <SelecaoGrupamentoMedida />
      <hr className="SelecaoMedidas__divisoria" />
      <>
        <AutoCompleteMedidas />
      </>
    </>
  );
}
